import React, { ReactElement, useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { Banner, BlockStack, Checkbox, Modal, Text } from '@shopify/polaris';

interface Props extends DIProps {
    open: boolean, setOpen: (e: any) => void, allLabels: any, selectedLabels: any, row: any, activityRefreshAction: () => void
}

const AddNewLabel = (props: Props) => {
    const { open, setOpen, allLabels, selectedLabels, row } = props;
    const [checked, setChecked] = useState<string[]>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);

    useEffect(() => {
        if (open) { // Only reset when modal is opened
            const initialChecked = selectedLabels ? selectedLabels.map((label: any) => label.id) : [];
            setChecked(initialChecked);
            setSelectAll(initialChecked.length > 0 && initialChecked.length === allLabels.length);
        }
    }, [open, selectedLabels, allLabels]); // Reset only when modal opens

    const getAssignedLabels = () => {
        const result = allLabels.filter((item: any) =>
            checked.some((id: any) => id === item.id)
        ).map(({ id, name }: any) => ({ id, name }));
        return result;
    }
    const addLabels = () => {
        setLoader(true);
        const payload = {
            "container_id": row?.container_id ?? "",
            "assigned_labels": getAssignedLabels()
        }

        props.di.POST("shopifyhome/request/saveProductLabels", payload).then((res: any) => {
            if (res?.success) {
                props.success(res?.message ?? "Labels updated successfully")
            }
            else {
                props.error(res?.message ?? "Oops! Some error occured.")
            }
            setLoader(false);
            setOpen(false);
            props.activityRefreshAction();
            setChecked([]);
        });

    }

    const handleCheckboxChange = (id: string) => {
        let tempCheckboxes = [...checked];
        if (tempCheckboxes.includes(id)) tempCheckboxes.splice(tempCheckboxes.indexOf(id), 1);
        else tempCheckboxes.push(id);
        setChecked(tempCheckboxes);
        setSelectAll(tempCheckboxes.length > 0 && tempCheckboxes.length === allLabels.length);
    }

    return (
        <>
            {allLabels?.length == 0 ?
                <Modal open={open} onClose={() => setOpen(false)} title="Add Label(s)">
                    <Modal.Section>
                        <BlockStack>
                            <Banner>
                                <Text as='p' fontWeight='bold'>No labels found. Kindly go to settings section and create labels.</Text>
                            </Banner>
                        </BlockStack>
                    </Modal.Section>
                </Modal> :
                <Modal open={open} onClose={() => setOpen(false)} title="Add Label(s)" primaryAction={allLabels?.length == 0 ? {} : { content: "Add", loading: loader, onAction: addLabels }} secondaryActions={allLabels?.length == 0 ? [] : [{ content: "Cancel", disabled: loader, onAction: () => setOpen(false) }]}>
                    <Modal.Section>
                        {allLabels?.length == 0 ? <BlockStack>
                            <Text as='p' fontWeight='bold'>No labels found. Kindly go to settings section and create labels.</Text>
                        </BlockStack>
                            : <BlockStack gap={"100"}>
                                <Checkbox label={<Text as='p' fontWeight='medium' variant='bodyMd' tone='subdued'>Select All</Text>} checked={selectAll} onChange={(e: any) => {
                                    setSelectAll(e);
                                    if (e) setChecked(allLabels.map((label: any) => label.id));
                                    else setChecked([]);
                                }} />
                                {
                                    allLabels.map((item: any, ind: number) => {
                                        return (
                                            <Checkbox label={item.name} key={ind} checked={checked.includes(item.id)} onChange={() => handleCheckboxChange(item.id)} />
                                        )
                                    })
                                }
                            </BlockStack>}
                    </Modal.Section>
                </Modal>}
        </>
    )
}

export default DI(AddNewLabel);